export default "__VITE_ASSET__CZ8d4R$w__"